var _style, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Ellipse_2_186 {\n\tanimation: 1.2s linear 0s infinite normal forwards running Ellipse_2_186;\n\ttransform-box: fill-box;\n\ttransform-origin: 50% 50%;\n\ttransform: translateX(300px) translateY(300px);\n}\n@keyframes Ellipse_2_186 {\n\t0% {\n\t\ttransform: translateX(500px) translateY(500px);\n\t\trx: 200px;\n\t\try: 200px;\n\t\topacity: 1;\n\t}\n\t100% {\n\t\ttransform: translateX(500px) translateY(500px);\n\t\trx: 375px;\n\t\try: 375px;\n\t\topacity: 0;\n\t}\n}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0_553)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#7EBFC9",
    className: "Ellipse_2_186",
    rx: 200,
    ry: 200
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(380 371)",
    clipPath: "url(#clip_1_574)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EAF8FA",
    transform: "translate(500 500)",
    rx: 200,
    ry: 200
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(380 371)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.19 181.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.485 0H3.40342C2.50078 0 1.63511 0.35858 0.99684 0.996846C0.358574 1.63511 0 2.50079 0 3.40343C0 4.30608 0.358574 5.17174 0.99684 5.81001C1.63511 6.44827 2.50078 6.80685 3.40342 6.80685H156.485C157.387 6.80685 158.253 6.44827 158.891 5.81001C159.529 5.17174 159.888 4.30608 159.888 3.40343C159.888 2.50079 159.529 1.63511 158.891 0.996846C158.253 0.35858 157.387 0 156.485 0Z",
    fill: "#0E7F8A",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.485 0.418396H3.40342C2.50078 0.418396 1.63511 0.776977 0.99684 1.41524C0.358574 2.05351 0 2.91919 0 3.82184C0 4.72448 0.358574 5.59015 0.99684 6.22842C1.63511 6.86668 2.50078 7.22527 3.40342 7.22527H156.485C157.387 7.22527 158.253 6.86668 158.891 6.22842C159.529 5.59015 159.888 4.72448 159.888 3.82184C159.888 2.91919 159.529 2.05351 158.891 1.41524C158.253 0.776977 157.387 0.418396 156.485 0.418396V0.418396Z",
    fill: "#0E7F8A",
    transform: "translate(0 12.42)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.485 0.836823H3.40342C2.50078 0.836823 1.63511 1.1954 0.99684 1.83367C0.358574 2.47193 0 3.33761 0 4.24025C0 5.14289 0.358574 6.00857 0.99684 6.64683C1.63511 7.28509 2.50078 7.64365 3.40342 7.64365H156.485C156.932 7.64365 157.374 7.55564 157.787 7.3846C158.2 7.21356 158.575 6.96287 158.891 6.64683C159.207 6.33079 159.458 5.95559 159.629 5.54267C159.8 5.12975 159.888 4.68719 159.888 4.24025C159.888 3.79331 159.8 3.35072 159.629 2.9378C159.458 2.52488 159.207 2.1497 158.891 1.83367C158.575 1.51763 158.2 1.26694 157.787 1.0959C157.374 0.92486 156.932 0.836822 156.485 0.836823Z",
    fill: "#0E7F8A",
    transform: "translate(0 24.84)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5296 57.5008V0.637131H12.3884C8.137 0.643461 4.053 2.29472 0.991923 5.24499V35.7846C0.982798 35.7846 0.982801 35.7755 0.973677 35.7755V55.7581C0.982801 55.7581 0.982798 55.7581 0.991923 55.7672V77.6112L14.7607 67.5834L28.5296 77.6112V57.5008Z",
    fill: "#0E7F8A",
    transform: "translate(24.97 180.64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.524345 0.0329285V18.4917C39.4493 18.4461 123.075 18.3548 160.321 18.2453C172.156 18.2089 181.745 12.1867 181.992 0.507391L181.545 0.042034L0.524345 0.0329285Z",
    fill: "#0E7F8A",
    transform: "translate(58.52 219.03)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.541 4.33033e-08H38.4596C33.409 -0.000239625 28.4077 0.994385 23.7415 2.92708C19.0752 4.85977 14.8354 7.69268 11.264 11.264C7.69268 14.8354 4.85977 19.0752 2.92708 23.7415C0.994386 28.4077 -0.000239625 33.409 4.33033e-08 38.4596V203.978C4.33033e-08 216.131 6.15902 227.838 18.9698 233.632V210.182C16.0469 206.485 14.4356 201.92 14.3893 197.207C14.4066 191.378 16.7299 185.792 20.8518 181.671C24.9737 177.549 30.5592 175.225 36.3884 175.208H201.541C206.592 175.208 211.593 174.214 216.259 172.281C220.926 170.348 225.166 167.515 228.737 163.944C232.308 160.373 235.141 156.133 237.074 151.467C239.007 146.8 240.001 141.799 240.001 136.748V38.4596C240.001 33.409 239.007 28.4077 237.074 23.7415C235.141 19.0752 232.308 14.8354 228.737 11.264C225.166 7.69268 220.926 4.85977 216.259 2.92708C211.593 0.994385 206.592 -0.000239625 201.541 4.33033e-08V4.33033e-08ZM109.913 146.074C78.808 146.074 53.588 123.29 53.588 95.1956H130.097C161.202 95.1956 186.413 117.979 186.413 146.074H109.913ZM130.088 80.0034H53.588C53.588 51.9 78.808 29.1253 109.913 29.1253H186.413C186.413 57.2196 161.193 80.0034 130.088 80.0034V80.0034Z",
    fill: "#0E7F8A",
    transform: "translate(0 0)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0_553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1_574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 257.61
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLoader);
export default __webpack_public_path__ + "static/media/green_loader.d9b91bafd6d05557ae6ca3350945e67f.svg";
export { ForwardRef as ReactComponent };